import * as qs from 'qs';
import { useCallback } from 'react';
import { useLocation } from 'react-router';

import type { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';

export const useGenerateDialogPath = () => {
  const location = useLocation();
  return useCallback(
    (
      dialogId: DialogKey,
      dialogParam: string,
      opts?: {
        basePath?: string;
        additionalParams?: Record<string, string | string[]>;
      }
    ) =>
      `${opts?.basePath || location.pathname}${qs.stringify(
        {
          ...qs.parse(location.search, {
            ignoreQueryPrefix: true,
          }),
          [`${dialogId}`]: dialogParam,
          ...opts?.additionalParams,
        },
        {
          addQueryPrefix: true,
          arrayFormat: 'comma',
        }
      )}`,
    [location.pathname, location.search]
  );
};
